<template>
  <div class="car-list">
    <ul>
      <li class="car-item" v-for="(item,index) in carList" :key="index">
        <div class="car-header" @click="setDefaultCar(item)">
          <div class="select-icon" :class="{'yes' : item.hasDefault}"></div>
          <div class="text">当前默认车辆</div>
        </div>
        <div class="car-info" @click="selectCar(item)">
          <div class="car-icon" @click="carClick(item)">
            <img src="../../assets/image/my-car.png" alt="">
          </div>
          <div class="car-flex" @click="carClick(item)">
            <div class="car-name">{{item.carNo}}</div>
            <div class="car-vin">VIN码 {{item.vin}}</div>
          </div>
          <div class="car-del" @click="delCar(item)" v-if="!isSelect">
            <img src="../../assets/image/del.png" alt="">
          </div>
          <div class="car-del" v-else>
            <img src="../../assets/img/icon-right.png" alt="">
          </div>
        </div>
      </li>
      <pi-no-list-data :list="carList" text="暂无车牌">
        <img
          src="@/picture/no-data-icon/car.png"
          class="no-list-icon"
        />
      </pi-no-list-data>
    </ul>
    <div class="add-car">
      <pi-button type="primary" @click="addCar" block>添加车牌</pi-button>
    </div>
  </div>
</template>
<script>
import {getCarList, delCar, setDefaultCar, chargeCarno} from "../../common/api";
import noListData from "@/components/pi-no-list-data/pi-no-list-data.vue";
export default {
  name: 'car-list',
   components: {
    [noListData.name]: noListData,
  },
  data(){
    return{
      carList: [],
      isSelect: false,
      pageType: ''
    }
  },
  methods: {
    addCar(){
      this.$router.push({
          name: "my-license-plate-add",
        });
    },
    getCarList(){
      getCarList(null)
        .then(response => {
          if ( response.status == this.$config.ajaxStatus) {
            this.carList = response.data;
          }

        })
    },
    setDefaultCar(item){
      setDefaultCar({pkid:item.pkid}, true)
            .then(data => {
              if (data.status === this.$config.ajaxStatus) {
                this.$toast("设置成功");
                this.getCarList();
              }
            })
            .catch(() => {
              this.$toast("设置失败");
            });
    },
    delCar(item){
      this.$dialog
        .confirm({
          message: "确定要删除吗",
          confirmButtonText: "确定",
          confirmButtonColor: "#14CC80",
          closeOnPopstate: true
        })
        .then(() => {
          delCar({pkid:item.pkid}, true)
            .then(data => {
              if (data.status === this.$config.ajaxStatus) {
                this.$toast("删除成功");
                if(this.carList.length == 1){
                  window.history.go(-1)
                }else{
                  this.getCarList();
                }
                
              }else{
                this.$toast(data.msg);
              }
            })
            .catch(() => {
              this.$toast("删除失败");
            });
        })
        .catch(() => {
          // on cancel
        });
    },
    carClick(item){
      if(!this.isSelect){
        this.$router.push({
          name: "my-license-plate-add",
          query: {
            carNo: item.carNo,
            pkid: item.pkid,
            vin: item.vin,
          }
        });
      }
    },
    selectCar(item){
      if(this.isSelect){
        let orderNo = this.$route.query.orderNo;
        if(orderNo){
          chargeCarno({carNo:item.carNo,orderNo: orderNo}, true).then(data => {
            if (data.status === this.$config.ajaxStatus) {
              this.$toast("修改成功");
              window.history.go(-1);
            }else{
              this.$toast(data.msg);
            }
          })
        }else{
          this.$common.save('selectCar',item,1);
          window.history.go(-1);
        }
      }
    }
  },
  mounted() {
    let query = this.$route.query;
    if(query && query.type == 'select'){
      this.isSelect = true;
      this.pageType = query.type;
    }
    this.getCarList();
    this.$common.bodyAddBg();
  },
  destroyed() {
    this.$common.removeBodyBg();
  },
}
</script>
<style lang="less">
  .car-list{
    height: 100%;
    display: flex;
    flex-direction: column;
    
    ul{
      flex: 1;
      padding: 0.2rem;
      overflow-y: auto;
      -webkit-overflow-scrolling: touch;
    }
    .add-car{
      padding: 0.4rem;
      background-color: #fff;
    }
    .car-item{
      padding: 0 0.2rem;
      background-color: #fff;
      .car-header{
        padding: 0.07rem 0;
        border-bottom: 0.01rem solid #eee;
        font-size: 0;
        .select-icon{
          display: inline-block;
          width: 0.2rem;
          height: 0.2rem;
          vertical-align: top;
          background-image: url('../../assets/image/radio.png');
          background-size: 100% 100%;
          margin: 0.03rem 0;
        }
        .select-icon.yes{
          background-image: url('../../assets/image/radio-yes.png');
        }
        .text{
          font-size: 0.18rem;
          color: #999;
          line-height: 0.25rem;
          margin-left: 0.1rem;
          display: inline-block;
          vertical-align: top;
        }
      }
      .car-info{
        padding: 0.25rem 0.1rem;
        display: flex;
        .car-icon{
          width: 0.8rem;
          height: 0.8rem;
          img{
            width: 100%;
            height: 100%;
          }
        }
        .car-flex{
          flex: 1;
          color: #666;
          padding-left: 0.2rem;
          .car-name{
            font-size: 0.36rem;
            line-height: 0.5rem;
          }
          .car-vin{
            font-size: 0.24rem;
            line-height: 0.31rem;
          }
        }
        .car-del{
          padding-top: 0.15rem;
          img{
            width: 0.48rem;
            height: 0.48rem;
          }
        }
      }
    }
  }
</style>